import { Trophy } from "lucide-react";
import { mediaUrl } from "@/lib/api";
import { Logo } from "@/components/tss/Ornaments";

export const TopBar = ({ config, cats, picks, voted, onJump }) => {
  const done = cats.filter((c) => picks[c.id] || voted[c.id]).length;
  return (
    <div className="sticky top-0 z-30 border-b border-gold/40 bg-ivory/95 backdrop-blur-md">
      <div className="mx-auto flex max-w-2xl items-center gap-3 px-4 py-2.5">
        {config.award_logo_url ? (
          <img src={mediaUrl(config.award_logo_url)} alt="TSS Sharod Shamman logo" data-testid="topbar-award-logo" className="h-11 w-11 shrink-0 rounded-full bg-white object-contain p-0.5 ring-2 ring-gold" />
        ) : (
          <Logo url={config.logo_url} size={40} />
        )}
        <p className="min-w-0 flex-1 truncate font-display text-lg font-bold text-maroon">{config.hero_title}</p>
        <span data-testid="progress-indicator" className="shrink-0 rounded-full bg-maroon px-3 py-1 text-xs font-semibold text-ivory">{done}/{cats.length}</span>
        {config.leaderboard_public && (
          <a href="/leaderboard" data-testid="leaderboard-link" className="shrink-0 rounded-full border border-gold p-1.5 text-maroon" aria-label="Leaderboard">
            <Trophy className="h-4 w-4" />
          </a>
        )}
      </div>
      <div className="mx-auto flex max-w-2xl gap-2 overflow-x-auto px-4 pb-3 [scrollbar-width:none]">
        {cats.map((c, i) => {
          const on = picks[c.id] || voted[c.id];
          return (
            <button
              key={c.id}
              type="button"
              onClick={() => onJump(c.id)}
              data-testid={`category-pill-${c.key || c.id}`}
              className={`shrink-0 rounded-full border-2 px-4 py-2 text-[15px] font-semibold transition-colors sm:text-base ${on ? "border-forest bg-forest text-white" : "border-gold/60 bg-white text-maroon"}`}
            >
              {i + 1}. {c.name_en.split(/[,&–]/)[0].trim()}
            </button>
          );
        })}
      </div>
    </div>
  );
};
